/*
Copyright 2019 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

export const DEFAULT_CONTENT_ITEM = "https://ns.adobe.com/personalization/default-content-item";
export const DOM_ACTION = "https://ns.adobe.com/personalization/dom-action";
export const HTML_CONTENT_ITEM = "https://ns.adobe.com/personalization/html-content-item";
export const JSON_CONTENT_ITEM = "https://ns.adobe.com/personalization/json-content-item";
export const RULESET_ITEM = "https://ns.adobe.com/personalization/ruleset-item";
export const REDIRECT_ITEM = "https://ns.adobe.com/personalization/redirect-item";
export const MESSAGE_IN_APP = "https://ns.adobe.com/personalization/message/in-app";
export const MESSAGE_CONTENT_CARD = "https://ns.adobe.com/personalization/message/content-card";
export const MESSAGE_NATIVE_ALERT = "https://ns.adobe.com/personalization/message/native-alert";
export const MEASUREMENT_SCHEMA = "https://ns.adobe.com/personalization/measurement";
export const EVENT_HISTORY_OPERATION = "https://ns.adobe.com/personalization/eventHistoryOperation";